/** import package [start] */
import { TbFaceIdError } from 'react-icons/tb';
import { BiSupport } from 'react-icons/bi';
/** import package [end] */

/**
 * Error component for full screen
 * @returns JSX.Element
 */
const FullSizeLoaderError = (): JSX.Element => {
    return (
        <div className='d-flex align-items-center h-100'>
            <div className='m-auto text-center'>
                <span className='text-muted'>
                    <TbFaceIdError size={100} />
                </span>
                <div>
                    <small className='mt-1 fw-bold'>Sorry something went wrong, please try after sometime.</small>
                </div>
                <div>
                    <small className='text-muted'>
                        Contact
                        <a href='mailto:support@zeeve.io' className='text-decoration-none ms-1'>
                            <BiSupport className='me-1' />
                            support@zeeve.io
                        </a>
                    </small>
                </div>
            </div>
        </div>
    );
};

export default FullSizeLoaderError;
